<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: "会员名称 ", prop: "name", type: "input", isFuzzy: true, placeholder: "请输入会员名称"},
          ],
          complex: [
            {label: "卡号 ", prop: "code", type: "input", span: 12, isFuzzy: true, placeholder: "请输入卡号"},
            // {label: "姓名", prop: "name", type: "input", span:12,isFuzzy: true, placeholder: "请输入姓名"},
            {label: "手机", prop: "phone", type: "input", span: 12, isFuzzy: true, placeholder: "请输入手机"},
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '刷新',
            code:refresh,
          },
          {
            label: '批量新增',
            code:batchNew,
          },
          {
            label: '下载导入模版',
            code:downloadTemplate,
          },
          {
            label: '导入',
            code: 'import',
          },
          {
            label: '导出',
            code: 'export',
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          columns: [
            {label: '序号', prop: 'id', width: '80', align: 'center'},
            {label: '会员姓名', prop: 'name', width: '120', align: 'center'},
            {
              label: '会员类别名称',
              prop: 'memberCategoryId',
              width: '120',
              align: 'center',
            },
            {label: '生日', prop: 'memberBirthday', width: '120', align: 'center'},
            {label: '手机号', prop: 'phone', width: '120', align: 'center'},
            {label: '地址', prop: 'address', width: '150', align: 'center'},
            {
              label: '状态',
              prop: 'status',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('mbMember.status')
            },
            {label: '发卡门店', prop: 'storeId', width: '150', align: 'center'},
            {label: '允许积分', prop: 'generateIntegral', width: '120', align: 'center',type:'switch'},
            {label: '允许储值', prop: 'deposit', width: '120', align: 'center',type:'switch'},
            {label: '累计积分', prop: 'cumulativeIntegral', width: '100', align: 'center'},
            {label: '可使用积分', prop: 'usableIntegral', width: '100', align: 'center'},
            {label: '储值余额', prop: 'balance', width: '100', align: 'center'},
            {label: '会员有效期', prop: 'memberTerm', width: '120', align: 'center'},
            {label: '积分到期日', prop: 'integralCloseDate', width: '120', align: 'center'},
            {label: '储值到期日', prop: 'depositCloseDate', width: '120', align: 'center'},
            {label: '创建日期', prop: 'remarks', width: '120', align: 'center'},
          ],
          url: api.member.archives
        },
        addColumns: {
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '会员姓名',
              type: 'input',
              prop: 'name',
              rule: [{required: true, message: '请输入会员姓名'}],
              placeholder: "请输入会员姓名"
            },
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              url: api.member.category,
              rule: [{required: true, message: '请选择会员类别'}],
            },
            {
              label: '生日',
              type: 'datePicker',
              prop: 'memberBirthday',
              rule: [{required: true, message: '请选择会员生日'}]
            },
            {
              label: '地址',
              type: 'casaderSelect',
              prop: 'province',
              span: 24,
              specialRule: [{required: true}],
              casaderOptions: [{
                prop: 'province',
                data: [],
                childProps: 'city',
                param: {parentId: 0},
                url: api.getAreaList,
                rule: [{required: true, message: '请选择省！'}]
              }, {
                prop: 'city',
                data: [],
                childProps: 'area',
                url: api.getAreaList,
                rule: [{required: true, message: '请选择市！'}]
              }, {
                prop: 'area',
                data: [],
                url: api.getAreaList,
                rule: [{required: true, message: '请选择区！'}]
              }]
            },
            {
              label: '详细地址',
              type: 'map',
              prop: 'address',
              span: 24
            },
            {
              label: "经度",
              type: "input",
              prop: "longitude",
              max: 180,
              min: -180,
              precision: 5,
              hidden: true
            },
            {
              label: "纬度",
              type: "input",
              prop: "latitude",
              max: 90,
              min: -90,
              precision: 5,
              hidden: true
            },
            {
              label: '手机号',
              type: 'input',
              prop: 'phone',
              maxLength: 11,
              rule: [
                {required: true, message: '请输入手机号', trigger: 'blur'},
                {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
              ],
              placeholder: "请输入手机号"
            },
            {
              label: '状态',
              type: 'select',
              prop: 'status',
              data: this.$utils.getCacheStatus("mbMember.status")
            },
            {
              label: '发卡门店',
              type: 'select',
              prop: 'storeId',
              url: api.system.seStore,
              rule: [{required: true, message: '请选择发卡门店'}],
            },
            {
              label: '会有有效期',
              type: 'datePicker',
              prop: 'memberTerm',
              rule: [{required: true, message: '请选择会有有效期'}]
            },
            {
              label: '允许积分',
              type: 'switch',
              prop: 'generateIntegral',
            },
            {
              label: '允许储值',
              type: 'switch',
              prop: 'deposit',
            },
            {
              label: '累计积分',
              type: 'inputNumber',
              prop: 'cumulativeIntegral',
            },
            {
              label: '可使用积分',
              type: 'inputNumber',
              prop: 'usableIntegral',
            },
            {
              label: '储值余额',
              type: 'input',
              prop: 'balance',
            },
            {
              label: '积分到期日',
              type: 'datePicker',
              prop: 'integralCloseDate',
              rule: [{required: true, message: '请选择积分到期日'}]
            },
            {
              label: '储值到期日',
              type: 'datePicker',
              prop: 'depositCloseDate',
              rule: [{required: true, message: '请选择储值到期日'}]
            },
            {
              label: '备注',
              type: 'textarea',
              prop: 'remkars',
              isAllline: true
            },
          ],
          url: api.member.archives
        },
      };
    },
    created() {
    },
    methods: {}
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/member/Query.vue